export default __webpack_public_path__ + "static/media/paperFoldedSmall.b5ac90db.jpg";